module.exports = __webpack_public_path__ + "static/media/julioft.e110413a.png";